import AxiosInterceptor from "api/interceptor";

const chiller = new AxiosInterceptor();

export default {
  get() {
    return chiller.get("/chiller");
  }
};
